import { reports as reportsRoute } from '../../../data/enums/Route';
import { getFilterConfig } from '../../../utils/filter';
import { FILTER } from '../../../data/enums/filter';

const title = 'Goods Received Report';

const breadCrumb = [reportsRoute];

const filter = getFilterConfig([FILTER.BRAND, FILTER.SUB_D]);

export {
  breadCrumb as breadCrumbConfig, filter as filterConfig, title
};
